import gql from 'graphql-tag'
export default gql`mutation publishRecipeMutation($recipeId: Int!) {
  publishRecipe(recipeId: $recipeId) {
    success
  }
}`